import { type Action, type ThunkDispatch } from '@reduxjs/toolkit';

import { apiFactory, Editions } from '@app/client';
import { type EditionsType } from '@app/client/common/structs/emoji/editions';

import { type RootState } from '../reducers';
import { ACTION_SET_EDITIONS, type EditionsActionsTypes } from '../types/editions';

import { setError } from './error';

export function getEmojiEditions() {
    return async function (dispatch: ThunkDispatch<RootState, void, Action>): Promise<void> {
        const result = await apiFactory().call(Editions.getEditions, {});

        try {
            if (result.ok) {
                dispatch(setEmojiEditions(result.value));
            } else {
                dispatch(setError({ error: result, notify: true }));
            }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error: any) {
            dispatch(setError({ ...error, notify: true }));
        }
    };
}

export function setEmojiEditions(editions: EditionsType): EditionsActionsTypes {
    return {
        type: ACTION_SET_EDITIONS,
        editions,
    };
}
